import { jsxs as t, jsx as a } from "react/jsx-runtime";
import "react";
import { classNames as n } from "../../utilities/index.js";
import "./index.css.js";
const p = _ref => {
    let {
      type: e = "checkbox",
      id: s,
      group: m,
      required: r,
      labelText: l,
      className: i,
      checkboxStyle: o,
      error: h,
      errorText: b,
      groupClass: c,
      ...x
    } = _ref;
    const d = n({
      [c]: c,
      "sash-FormGroup-Checkbox": e === "checkbox" || e === "radio" && o,
      "sash-FormGroup-Radio": !o && e !== "checkbox"
    });
    return /* @__PURE__ */t("div", {
      className: `${d}`,
      children: [/* @__PURE__ */t("label", {
        htmlFor: s,
        className: `sash-Label mb-5 flex items-center ${r ? "text-required" : ""}`,
        children: [/* @__PURE__ */a("input", {
          type: e,
          name: m || s,
          id: s,
          className: `sash-Checkbox absolute opacity-0 ${i || ""}`,
          required: r,
          ...x
        }), /* @__PURE__ */a("span", {
          className: "sash-FauxCheckbox relative mr-2.5 cursor-pointer",
          "data-id": s
        }), /* @__PURE__ */a("div", {
          className: "static leading-6",
          children: l
        })]
      }), h && /* @__PURE__ */a("p", {
        "aria-describedby": s,
        className: "-mt-2.5 mb-0 border-2 border-red p-1 text-sm text-red",
        children: b
      })]
    });
  },
  f = p;
export { f as default };